export default __webpack_public_path__ + "static/media/host_notes_icon.4be7ec7b.svg";